import { createFileRoute } from '@tanstack/react-router'
import { KeyGate } from '@/crypto/KeyGate'
import { Triagem } from '@/features/triagem/Triagem'

/**
 * Formulários antes da primeira sessão. Rota clínica: as respostas só abrem com
 * a chave, então a tela inteira fica dentro do `KeyGate`.
 */
export const Route = createFileRoute('/_app/app/triagem')({
  staticData: { crumb: { label: 'Triagem' } },
  component: function TriagemRoute() {
    return (
      <KeyGate motivo="As respostas da triagem ficam cifradas e só abrem com a sua chave.">
        <Triagem />
      </KeyGate>
    )
  },
})
